import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fo-principal',
  templateUrl: './fo-principal.component.html',
  styleUrls: ['./fo-principal.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class FoPrincipalComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly NEW_SELFCARE_URL = environment.NEW_SELFCARE_URL;
  private teardownCallbacks: Array<() => void> = [];

  constructor(private hostRef: ElementRef<HTMLElement>) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const root = this.hostRef.nativeElement.shadowRoot;
    if (!root) {
      return;
    }

    if (!root.querySelector('link[data-vmco-footer-styles]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'assets/footer/footer-web.css';
      link.setAttribute('data-vmco-footer-styles', 'true');
      root.prepend(link);
    }

    const toggles = root.querySelectorAll<HTMLInputElement>('.footer-accordion-toggle');
    toggles.forEach((toggle) => {
      const ariaControls = toggle.getAttribute('aria-controls');
      if (!ariaControls) {
        return;
      }

      const content = root.getElementById(ariaControls);
      const links = content ? (content.querySelectorAll('a') as NodeListOf<HTMLAnchorElement>) : null;
      if (!content || !links) {
        return;
      }

      const updateAriaState = () => {
        const isExpanded = toggle.checked;
        toggle.setAttribute('aria-expanded', isExpanded.toString());
        content.setAttribute('aria-hidden', (!isExpanded).toString());

        if (isExpanded) {
          content.removeAttribute('inert');
          links.forEach((link) => link.setAttribute('tabindex', '0'));
        } else {
          content.setAttribute('inert', '');
          links.forEach((link) => link.setAttribute('tabindex', '-1'));
        }
      };

      updateAriaState();
      const handler = () => updateAriaState();
      toggle.addEventListener('change', handler);
      this.teardownCallbacks.push(() => toggle.removeEventListener('change', handler));
    });
  }

  ngOnDestroy() {
    this.teardownCallbacks.forEach((callback) => callback());
    this.teardownCallbacks = [];
  }

}
